import React, { SVGProps } from 'react';

const RouletteIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.33325 5.87988C1.33325 3.67074 3.12411 1.87988 5.33325 1.87988H14.6666C16.8757 1.87988 18.6666 3.67074 18.6666 5.87988V15.2132C18.6666 17.4224 16.8757 19.2132 14.6666 19.2132H5.33325C3.12411 19.2132 1.33325 17.4224 1.33325 15.2132V5.87988ZM9.33325 7.54655C9.33325 8.83521 8.28858 9.87988 6.99992 9.87988C5.71125 9.87988 4.66658 8.83521 4.66658 7.54655C4.66658 6.25788 5.71125 5.21322 6.99992 5.21322C8.28858 5.21322 9.33325 6.25788 9.33325 7.54655ZM12.9999 15.8799C14.2886 15.8799 15.3333 14.8352 15.3333 13.5465C15.3333 12.2579 14.2886 11.2132 12.9999 11.2132C11.7113 11.2132 10.6666 12.2579 10.6666 13.5465C10.6666 14.8352 11.7113 15.8799 12.9999 15.8799Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default RouletteIcon;
